<div class="breadcrumbs d-flex align-items-center bg-light py-3 ps-2 mb-3" *ngIf="breadcrumbsService.items.length && !breadcrumbsService.hidden">
    <ng-container *ngFor="let item of breadcrumbsService.items; let last = last;">
        <syslink-link *ngIf="!last" class="mx-1" url="/{{item.path}}" [text]="(item.text || '') | translate"></syslink-link>

        <span *ngIf="!last" class="px-2"><i class="fas fa-chevron-right"></i></span>

        <syslink-button *ngIf="last" class="last-item" [text]="(item.text || '') | translate" mode="text" type="normal" [hoverStateEnabled]="false"></syslink-button>
    </ng-container>
</div>